/**
 * Hand-drawn thin-stroke icons rather than an icon font. The hotel's own
 * site uses fine line work, and a 1.35 stroke at 19px matches it far
 * better than a filled set would. Every path is on a 24 grid.
 */

const PATHS = {
  today: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  people: (
    <>
      <circle cx="9.5" cy="9" r="3.4" />
      <path d="M3.5 19.5c.6-3.2 3-5 6-5s5.4 1.8 6 5" />
      <path d="M16 6.2a3.2 3.2 0 0 1 0 6" />
      <path d="M18 14.9c1.9.5 3.2 2.1 3.6 4.6" />
    </>
  ),
  rtw: (
    <>
      <path d="M12 3.2l6.8 2.4v6c0 4.2-2.7 7.3-6.8 8.9-4.1-1.6-6.8-4.7-6.8-8.9v-6z" />
      <path d="M9 12.1l2.2 2.2L15.2 10" />
    </>
  ),
  absence: (
    <>
      <rect x="4" y="5.2" width="16" height="14.6" rx="2" />
      <path d="M4 9.6h16M8.5 3.4v3.6M15.5 3.4v3.6" />
    </>
  ),
  starters: (
    <>
      <path d="M12 4.5v10" />
      <path d="M8.2 10.7L12 14.5l3.8-3.8" />
      <path d="M4.5 17.5v1.2a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-1.2" />
    </>
  ),
  sync: (
    <>
      <path d="M20 12a8 8 0 0 1-13.7 5.6" />
      <path d="M4 12a8 8 0 0 1 13.7-5.6" />
      <path d="M17.4 3.2v3.5h-3.5M6.6 20.8v-3.5h3.5" />
    </>
  ),
  audit: (
    <>
      <path d="M6 3.6h9l4 4v12.8H6z" />
      <path d="M14.6 3.6v4.2h4.2" />
      <path d="M9 13h6M9 16.4h4" />
    </>
  ),
  block: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6.5 6.5l11 11" />
    </>
  ),
  hold: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M10 9v6M14 9v6" />
    </>
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M8.4 12.2l2.6 2.6 4.6-5" />
    </>
  ),
} as const

export type IconName = keyof typeof PATHS

export function Icon({
  name,
  size = 19,
  className = 'ico',
}: {
  name: IconName
  size?: number
  className?: string
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  )
}
